import { useFormikContext } from "formik"

import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import { useDateTime } from "../../../../../../modules/localization/useDateTime"
import { SelectedPriceListItem } from "../../../createOrderTypes"
import { useCreateOrderDialogType } from "../../../hooks/useCreateOrderDialogType"
import { DynamicConfigKey, MeetingServiceTabValues } from "../../form/formTypes"
import {
    DeadlineMessageDisplayType,
    DeadlineMessageQuery,
    fetchDeadlineMessage,
    selectDeadlineMessage,
} from "../../shop/delivery/deliveryApi"
import { buildDeadlineDeliveryTime, hasProductWishDelivery } from "../../shop/delivery/helpers"

import { MessageCard } from "./MessageCard"

type DeadlineMessageCardProps = Readonly<{
    priceList: SelectedPriceListItem
}>

export function DeadlineMessageCard({ priceList }: DeadlineMessageCardProps) {
    const { values } = useFormikContext<MeetingServiceTabValues>()
    const { isSpecialOrder } = useCreateOrderDialogType()
    const dateTimeFactory = useDateTime()

    const deliveries = values[DynamicConfigKey.MULTIPLE_DELIVERIES]
    const deliveryTime = buildDeadlineDeliveryTime(deliveries, dateTimeFactory)

    const { data: deadlineMessage } = useApiQuery(fetchDeadlineMessage, {
        queryName: DeadlineMessageQuery.DELIVERY_DEADLINE_MESSAGE,
        dependencies: {
            merchantId: priceList.merchantId,
            deliveryTime,
            productWish: hasProductWishDelivery(deliveries),
            priceListId: priceList.priceListId,
            shopId: priceList.shopId,
        },
        select: selectDeadlineMessage,
        enabled: !!deliveryTime && !isSpecialOrder,
    })

    if (
        isSpecialOrder ||
        !deadlineMessage ||
        deadlineMessage.isConfirmed ||
        !deadlineMessage.message.displayRule ||
        deadlineMessage.displayType !== DeadlineMessageDisplayType.CARD
    ) {
        return null
    }

    return <MessageCard text={deadlineMessage.message.displayRule} severity="warning" />
}
